// Module
var code = ` <h3 class="vx-sc-title">Scenes</h3> <ul id="vx-sc-switcher"></ul>`;
// Exports
export default code;